import { axios } from '@getgreenline/homi-shared'
import { CompaniesModels } from '@getgreenline/companies'

export interface IOrganizationWithCompanies {
  id: number
  name: string
  companies: Pick<CompaniesModels.ICompany, 'id' | 'name' | 'province'>[]
}

export const getOrganizationWithCompanies = (
  organizationId: number,
): Promise<IOrganizationWithCompanies> =>
  axios.get(`/api/v1/admin/organizations/${organizationId}`).then((r) => r.data)

export const removeCompanyFromOrganization = (
  organizationId: number,
  companyId: number,
): Promise<void> =>
  axios
    .delete(`/api/v1/admin/organizations/${organizationId}/migrations/${companyId}`)
    .then(() => undefined)

export interface IOrgProductSyncStarted {
  organizationId: number
  companyCount: number
  productCount: number
}

/**
 * Kicks off a re-emit of product.updated for every product already in the organization's product
 * groups, so product-service can re-ingest them into OpenSearch. Returns 202 immediately with the
 * counts the run is expected to cover; the sync itself continues server-side.
 */
export const syncOrganizationProducts = (organizationId: number): Promise<IOrgProductSyncStarted> =>
  axios.post(`/api/v1/admin/organizations/${organizationId}/sync-products`).then((r) => r.data)
